import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaPlusCircle } from 'react-icons/fa';

const AdminCreateRestaurant = () => {
  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  // const [ownerId, setOwnerId] = useState('');
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const token = localStorage.getItem('adminToken');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        '/api/admin/restaurants',
        // { name, address, owner: ownerId },
        { name, address, email },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      navigate('/admin/restaurants');
    } catch (error) {
      console.error('Error creating restaurant:', error);
    }
  };

  return (
    <div className='container mx-auto px-4 py-8 max-w-[600px]'>
      <h1 className='text-3xl font-bold mb-6 flex items-center'>
        <FaPlusCircle className='mr-3' /> Create Restaurant
      </h1>
      <form
        onSubmit={handleSubmit}
        className='bg-white p-6 shadow-lg rounded-lg'
      >
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Restaurant Name
          </label>
          <input
            type='text'
            value={name}
            onChange={(e) => setName(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Address
          </label>
          <input
            type='text'
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        {/* <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Owner ID
          </label>
          <input
            type='text'
            value={ownerId}
            onChange={(e) => setOwnerId(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div> */}
        <div className='mb-4'>
          <label className='block text-gray-700 text-sm font-bold mb-2'>
            Email
          </label>
          <input
            type='text'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className='w-full p-3 border rounded'
            required
          />
        </div>
        <button
          type='submit'
          className='bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200'
        >
          Create Restaurant
        </button>
      </form>
    </div>
  );
};

export default AdminCreateRestaurant;

// import React, { useState } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { FaSave } from 'react-icons/fa';

// const AdminCreateRestaurant = () => {
//   const [name, setName] = useState('');
//   const [address, setAddress] = useState('');
//   const [description, setDescription] = useState('');
//   const [loading, setLoading] = useState(false);
//   const token = localStorage.getItem('adminToken');
//   const navigate = useNavigate();

//   const handleCreate = async () => {
//     setLoading(true);
//     try {
//       await axios.post(
//         '/api/admin/restaurants',
//         { name, address, description },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       navigate('/admin/restaurants');
//     } catch (error) {
//       console.error('Error creating restaurant:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       <h1 className='text-3xl font-bold mb-8'>Create Restaurant</h1>
//       <div className='space-y-4'>
//         <div>
//           <label className='block mb-2 font-semibold'>Restaurant Name</label>
//           <input
//             type='text'
//             className='w-full p-3 border rounded'
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             placeholder='Enter restaurant name'
//           />
//         </div>
//         <div>
//           <label className='block mb-2 font-semibold'>Address</label>
//           <input
//             type='text'
//             className='w-full p-3 border rounded'
//             value={address}
//             onChange={(e) => setAddress(e.target.value)}
//             placeholder='Enter address'
//           />
//         </div>
//         <div>
//           <label className='block mb-2 font-semibold'>Description</label>
//           <textarea
//             className='w-full p-3 border rounded'
//             value={description}
//             onChange={(e) => setDescription(e.target.value)}
//             placeholder='Enter description'
//           />
//         </div>
//         <button
//           onClick={handleCreate}
//           className='inline-block bg-blue-500 text-white py-2 px-4 rounded'
//           disabled={loading}
//         >
//           <FaSave className='mr-2 inline' /> {loading ? 'Saving...' : 'Save'}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AdminCreateRestaurant;
